<template>
	<div class="event-list">
		<div class="page-container">
			<PageTitle ch="活動回顧" en="Event Review"></PageTitle>

			<p class="explain">
				利澤國際偶戲藝術村歷來舉辦許多常態型與季節性活動，包含【偶戲村學堂】、【偶戲表演】、【大師班課程】、【駐村藝術家成果展】、冬夏日營隊，以及不定期舉辦的特別企劃如：節慶活動、偶戲村OPEN DAY卡樂趴、老街輕旅行等，並於每兩年秋季盛大舉辦【利澤偶聚祭】，邀請國內外精彩的偶戲演出一同匯聚利澤，民眾來到偶戲村不僅飽覽偶戲知識，更能深入體驗偶戲的豐富內涵與美妙之處。
			</p>
			<p class="explain">
				Visitors can enjoy numerous activities in Lize Puppet Art Colony, including “Lize Lecture (Workshops / short classes)”, “Storytelling Theater”, “AIR Open Lab”, summer & winter camps, and irregular special events including small puppet show, Open Day: Color Party Carnival, Lize Old Street culture and art tour. There will be an annual festival “Lize International Puppet Festival” in autumn. Puppet performances from around the world are brought to Lize, which allows the audience to encounter closely the creative puppet artists from all over the world and experience the beauty of puppetry.
			</p>
			<ul class="filter">
				<li
					class="f-item"
					@click="cateFilter('全部')"
					:class="{ active: '全部' == currentTag }"
				>
					<div class="ch">全部</div>
					<div class="en">All</div>
				</li>
				<li
					:key="index"
					v-for="(tag, index) in eventTag"
					class="f-item"
					@click="cateFilter(tag.zh)"
					:class="{ active: tag.zh == currentTag }"
				>
					<div class="ch">{{ tag.zh }}</div>
					<div class="en">{{ tag.en }}</div>
				</li>
			</ul>
			<div class="artist-center">
				<div class="artist-lists">
					<div class="artist-card"
						:key="index"
						v-for="(item, index) in eventList.list">
						<router-link tag="div" :to="'/event/' + item.id">
							<img
								class="artist-img"
								:src="item.thumbs[0].url"
							></img>
							<div class="artist-title">{{ item.title }}</div>
						</router-link>
					</div>
				</div>
			</div>
			<el-pagination
				class="pagination"
				@current-change="changeCurrentPage"
				large
				layout="prev, pager, next"
				:total="totalEvents"
			>
			</el-pagination>
		</div>
	</div>
</template>

<script>
import PageTitle from "@/components/page_title";
import { mapActions, mapState } from "vuex";

export default {
	metaInfo: {
		title: "利澤國際偶戲藝術村"
	},
	name: "eventList",
	data() {
		return {
			currentEvent: "",
			filter: "全部",
			currentPop: {},
			totalEvents: 0,
			eventListR: {}
		};
	},
	mounted() {
		this.getEventsDataByPage();
	},
	methods: {
		...mapActions(["getEvent", "getEventByTag", "getEventContent"]),
		openSlide: function(id) {
			this.getEventContent(id).then(() => {
				this.currentPop = this.$store.state.event;
				$("html,body").scrollTop(0);
			});
		},
		cateFilter: function(tag) {
			this.$store.state.currentTag = tag;
			this.getEventByTag({ offset: 0, length: 10 });
		},
		changeCurrentPage(page) {
			this.$router.push({ query: { pages: page } });
		},
		getEventsDataByPage() {
			let page = this.$route.query.pages ? this.$route.query.pages : 1;
			this.getEventByTag({ offset: (page - 1) * 10, length: 10 });
		}
	},
	computed: {
		...mapState(["eventTag", "eventList", "currentTag"])
	},
	components: {
		PageTitle
	},
	watch: {
		$route() {
			this.getEventsDataByPage();
		},
		eventList: function() {
			this.totalEvents = this.eventList.total;
			$("html,body").scrollTop(0);
		}
	}
};
</script>
<style scoped lang="scss">
.f-item {
	margin: 3px !important;
}
.artist-lists{
	max-width: 1280px;
	margin: 35px 20px 80px;
	width: 100%;
	height: 100%;
	display: grid;
	grid-template-columns: repeat(1, minmax(0, 1fr));
	gap: 3rem 1rem;
	.artist-card{
		width: 100%;
		height: 100%;
		.artist-img{
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
		.artist-title{
			margin-top: 10px;
			line-height: 1.5;
		}
	}
}
@media (min-width:576px) {
	.artist-lists{
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}
}
@media (min-width:768px) {
	.artist-lists{
		grid-template-columns: repeat(3, minmax(0, 1fr));
	}
}
@media (min-width:992px) {
	.artist-lists{
		grid-template-columns: repeat(4, minmax(0, 1fr));
	}
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
@import '../../stylesheet/base.sass'
@import '../../stylesheet/layout.sass'
.event-list
  position: relative
  .pagination
    +flexLayout('center', 'row')
    margin: 50px 0 100px

  .explain
    max-width: 788px
    width: 100%
    font-size: $font-size-3-s
    line-height: 2
    margin-left: auto
    margin-right: auto
    margin-bottom: 20px
    padding: 0 20px
  .filter
    +flexLayout('center', 'row')
    flex-wrap: wrap
    max-width: 875px
    margin: auto
    .f-item
      +flexLayout('center', 'col')
      background-color: #01b6e2
      border-radius: 100px
      min-width: 161px
      min-height: 38px
      color: white
      margin: 0 20px 32px 20px
      cursor: pointer
      opacity: 0.6
      padding: 10px 15px
      max-width: 181px
      min-width: 150px
      text-align: center
      // height: 80px
      height: 40px
      padding: 5px 5px
      margin: 0
      border-radius: 0px
      height: 65px
      width: 175px
      max-width: initial
      min-width: initial
      @media screen and (max-width: 900px)
        margin: 0
        border-radius: 0px
        height: 65px
        width: 175px
        max-width: initial
        min-width: initial
      .en
        font-size: $font-size-4
        margin-top: 5px
      &:hover
        opacity: 1
    .active
      opacity: 1
  .artist-center
    +flexLayout('center', 'row')
    width: 100%
    .center-box
      +flexLayout('center', 'row')

    .artist
      max-width: 1280px
      margin: 0 auto
      margin-bottom: 80px
      width: 100%
      .a-item
        position: relative
        height: 275px
        width: 275px
        background-size: cover
        background-position: 50% 50%
        align-self: start
        margin: 35px 0 10px 0
        filter: brightness(0.5)
        cursor: pointer
      .title
        font-size: 18px
        font-weight: 500
        color: #222
        line-height: 1.3em;
</style>



// WEBPACK FOOTER //
// src/pages/event/event_list.vue